import PropTypes from "prop-types";
import * as React from "react";
import { characterLabel, characterStack } from "../../domain/shopImages";
import AvatarStack from "../AvatarStack/AvatarStack";

const VISIBLE_CHARACTERS = 3;

const moreCharacters = (count) => `${count} more characters`;

const toItem = (image) => ({
  key: image.imageId,
  src: image.squareUrl ?? image.url,
  alt: characterLabel(image) ?? "",
});

export default function CharacterStack({ characters, label, size, className }) {
  const { visible, overflow } = characterStack(VISIBLE_CHARACTERS, characters);

  return (
    <AvatarStack
      items={visible.map(toItem)}
      overflow={overflow}
      size={size}
      label={label}
      overflowLabel={moreCharacters}
      className={className}
    />
  );
}

CharacterStack.propTypes = {
  characters: PropTypes.arrayOf(
    PropTypes.shape({
      imageId: PropTypes.number.isRequired,
      url: PropTypes.string,
      squareUrl: PropTypes.string,
      label: PropTypes.string,
      characterName: PropTypes.string,
    }),
  ).isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md"]),
  className: PropTypes.string,
};
